"use strict";

require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.object.define-property");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var $ = require("jquery");
exports.NipRule = function () {
  $.validator.addMethod("nip", function (value) {
    value = value.replace(/[^0-9]/g, "");
    if (value.length === 10) {
      var nip_weight_table = [6, 5, 7, 2, 3, 4, 5, 6, 7];
      var sum = 0;
      for (var i = 0; i < nip_weight_table.length; i++) {
        sum += value.charAt(i) * nip_weight_table[i];
      }
      var last_number = sum % 11;
      if (parseInt(value.charAt(9)) === last_number) {
        return /^[0-9]{10}$/.test(value);
      }
    }
  }, $.validator.format("Numer NIP jest niepoprawny "));
}();